import angular from 'angular';
import timeComponent from './time-component';
import angularBootstrap from 'angular-ui-bootstrap';
import i18n from '../i18n';
import hours from './hours';
import militaryHours from './military-hours';
/**
* @ngdoc module
* @name akamai.components.time
*
* @guideline https://design.akamai.com/components/time-picker/
*
* @description
* The time control is an interactive component that allows users to select a time from
* an interactive dropdown menu. User can select the hour, minute and time of day.
* The hour and minute controls are configurable and can be displayed in set intervals. Time can
* be displayed with or without a meridian. This is best used as a filtering mechanism (i.e.
* filtering a report by a range of times).
*
* @example index.html
* <akam-time
*   ng-model="..."
*   minute-step="..."
*   hour-step="..."
*   is-disabled="..."
*   is-readonly="..."
*   no-meridian>
* </akam-time>
*
**/

export default angular.module('akamai.components.time', [
  angularBootstrap,
  i18n.name
])
  .factory('hours', hours)
  .factory('militaryHours', militaryHours)
  /**
   * @ngdoc directive
   * @name akamTime
   * @restrict E
   *
   * @description Creates a time picker control.
   *
   * @param {Object} ng-model The time value. An object with `hours` and `minutes` properties.
   * `hours` can be an integer between `0-23` and `minutes` can be an integer `0-59`.
   *
   * @param {Object} min-time The minimum time allowed. An object with `hours` and `minutes`
   * properties. `hours` can be an integer between `0-23` and `minutes` can be an integer `0-59`.
   *
   * @param {Object} max-time The maximum time allowed. An object with `hours` and `minutes`
   * properties. `hours` can be an integer between `0-23` and `minutes` can be an integer `0-59`.
   *
   * @param {boolean} [is-disabled=false] If disabled, no user interaction will be possible.
   *
   * @param {boolean} [is-readonly=false] If readonly, no user interaction will be possible but the
   * text will be easier to read.
   *
   * @param {number} [hour-step=1] The value used to increment/decrement the hour value.
   *
   * @param {number} [minute-step=15] The value used to increment/decrement the minute value.
   *
   * @param {*} [no-meridian] If present, the time will not have a meridian and will be rendered in
   * military time.
   */
  .component('akamTime', timeComponent);
